import { signOut } from "next-auth/react";
import Link from "next/link";
import { useContext } from "react";
import isUserMenuDisplayedContext from "@/contexts/userMenu.context";
import transparentDivContext from "@/contexts/transparentDiv.context";
import { FormattedMessage } from "react-intl";
import { useSession } from "next-auth/react";
import { fromSession } from "@/modules/user/domain/converter";
import { SessionNextAuthUser } from "@/modules/user/types/user.types";
import { useGetSession } from "@/modules/auth/auth.hooks";
import responsiveMenuContext from "@/contexts/responsiveMenu.context";
import { useRouter } from "next/navigation";

const UserMenu = () => {
  const { isUserMenuDisplayed, setIsUserMenuDisplayed } = useContext(
    isUserMenuDisplayedContext,
  );
  const { setIsTransparentDivDisplayed } = useContext(transparentDivContext);

  const { isResponsiveMenuDisplayed, setIsResponsiveMenuDisplayed } =
    useContext(responsiveMenuContext);

  const { isUserAdmin } = useGetSession();

  const closeMenu = () => {
    setIsUserMenuDisplayed(false);
    setIsTransparentDivDisplayed(false);
    setIsResponsiveMenuDisplayed(false);
  };

  const router = useRouter();
  return (
    <div
      className={"absolute z-50 bg-white px-3 py-2 rounded-lg shadow-lg w-36"}
    >
      <Link href={"/myAccount"} passHref>
        <p
          className={`mr-3 cursor-pointer hover:bg-slate-200 py-1 px-3 rounded-sm `}
          onClick={() => {
            closeMenu();
          }}
        >
          <FormattedMessage
            id="navbar.userMenu.profile"
            defaultMessage="Profile"
          />
        </p>
      </Link>
      {isUserAdmin && (
        <Link href={"/admin"} passHref>
          <p
            className={`mr-3 cursor-pointer hover:bg-slate-200 py-1 px-3 rounded-sm `}
            onClick={() => {
              closeMenu();
            }}
          >
            <FormattedMessage
              id="navbar.userMenu.admin"
              defaultMessage="Admin"
            />
          </p>
        </Link>
      )}
      <p
        className={`mr-3 cursor-pointer hover:bg-slate-200 py-1 px-3 rounded-sm `}
        onClick={async () => {
          // erasing cookie server side
          await fetch("/api/api-auth/logout", {
            method: "POST",
            credentials: "include",
          }).catch(() => {});

          // closing menu displaying in absolute
          closeMenu();

          // sign out next session
          signOut({ redirect: false });

          // redirection
          router.push("/");
        }}
      >
        <FormattedMessage
          id="navbar.userMenu.logout"
          defaultMessage="Log out"
        />
      </p>
    </div>
  );
};

export default UserMenu;
